"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonBlock = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _Button = require("../Button");
var _Container = require("../Container");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["buttonPrimary", "buttonSecondary", "alignment", "className", "slots", "slotProps", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classes = (0, _classVarianceAuthority.cva)(['flex', 'flex-col', 'md:flex-row', 'gap-5', 'w-full'], {
  variants: {
    alignment: {
      'left': ['justify-start'],
      'center': ['justify-center'],
      'right': ['justify-end']
    }
  }
});

/**
 * Button Block - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/blocks-buttonblock) | [DSM](https://sharphealthcare.notion.site/Button-block-fe3421084a964e9a80b2bd9061a651aa)
 *
 * @example
 *
 * <ButtonBlock
 *  buttonPrimary={{label: 'Primary'}}
 *  buttonSecondary={{label: 'Secondary'}}
 *  alignment="center" />
 *
 */
var ButtonBlock = exports.ButtonBlock = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _slots$buttonPrimaryC, _slots$buttonPrimary, _slots$buttonSecondar, _slots$buttonSecondar2;
  var buttonPrimary = _ref.buttonPrimary,
    buttonSecondary = _ref.buttonSecondary,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
    className = _ref.className,
    _ref$slots = _ref.slots,
    slots = _ref$slots === void 0 ? {} : _ref$slots,
    _ref$slotProps = _ref.slotProps,
    slotProps = _ref$slotProps === void 0 ? {} : _ref$slotProps,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ButtonPrimaryContainer = (_slots$buttonPrimaryC = slots.buttonPrimaryContainer) !== null && _slots$buttonPrimaryC !== void 0 ? _slots$buttonPrimaryC : _react.Fragment;
  var ButtonPrimary = (_slots$buttonPrimary = slots.buttonPrimary) !== null && _slots$buttonPrimary !== void 0 ? _slots$buttonPrimary : _Button.Button;
  var buttonPrimaryProps = slots.buttonPrimary ? slotProps.buttonPrimary : _objectSpread(_objectSpread({
    variant: 'filled'
  }, buttonPrimary), slotProps.buttonPrimary);
  var ButtonSecondaryContainer = (_slots$buttonSecondar = slots.buttonSecondaryContainer) !== null && _slots$buttonSecondar !== void 0 ? _slots$buttonSecondar : _react.Fragment;
  var ButtonSecondary = (_slots$buttonSecondar2 = slots.buttonSecondary) !== null && _slots$buttonSecondar2 !== void 0 ? _slots$buttonSecondar2 : _Button.Button;
  var buttonSecondaryProps = slots.buttonSecondary ? slotProps.buttonSecondary : _objectSpread(_objectSpread({
    variant: 'outlined'
  }, buttonSecondary), slotProps.buttonSecondary);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Container.Container, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    as: as,
    className: (0, _helpers.cn)(classes({
      alignment: alignment,
      className: className
    })),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonPrimaryContainer, _objectSpread(_objectSpread({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.buttonPrimaryContainer), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonPrimary, _objectSpread({}, buttonPrimaryProps))
    })), (buttonSecondary || slots.buttonSecondary) && /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonSecondaryContainer, _objectSpread(_objectSpread({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.buttonSecondaryContainer), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonSecondary, _objectSpread({}, buttonSecondaryProps))
    }))]
  }));
});